import { useTranslation } from 'react-i18next';
import { Flex, PageContainer } from '@/components';
import { WalletPageContextProvider } from './WalletPageContext';

import WalletPageContent from './WalletPageContent';

export function WalletPage() {
  const { t } = useTranslation(['common', 'payment']);
  return (
    <PageContainer title={t('common:labels.wallet')}>
      <Flex className="w-full min-h-full mx-auto">
        <WalletPageContextProvider>
          <WalletPageContent />
        </WalletPageContextProvider>
      </Flex>
    </PageContainer>
  );
}

export default WalletPage;
